/* MagSert — scroll reveal. Skipped under reduced motion (CSS shows everything).
   Re-queries on Shopify section load so the theme editor reveals re-rendered blocks. */
(function () {
  function observe(root) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    (root || document).querySelectorAll('.ms .reveal:not(.in), .ms.reveal:not(.in)').forEach(function (el) {
      io.observe(el);
    });
  }
  document.addEventListener('DOMContentLoaded', function () { observe(document); });
  if (document.readyState !== 'loading') observe(document);
  // Theme editor: reveal content when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { observe(e.target); });
})();
